import { reqAPI } from "../utils/fetch-request";

export async function getListBatch(params = {}){
  // Ensure we're supporting pagination parameters
  return reqAPI(`api/merchant/batches`, params)
}

export async function list(uuid){
  return reqAPI(`api/${uuid}/transactions`)
}

export async function detailTransaction(idTransaction){
  return reqAPI(`api/merchant/transactions/${idTransaction}`)
}

export async function detailBatch(idBatch){
  return reqAPI(`api/merchant/batches/${idBatch}`)
}

export async function checkVirtualAccountStatus(vaNumber) {
  return reqAPI('api/merchant/virtual-accounts/check-status-va', { va_number: vaNumber })
}

export async function getTransactionsList(params) {
  return reqAPI('api/merchant/transactions/list', params)
}

export async function updateCallbackUrl(callbackUrl) {
  const formData = new FormData();
  formData.append('callback_url', callbackUrl);
  return reqAPI('api/merchant/update-callback-url', formData, 'POST', true)
}

export async function resendCallback(transactionId) {
  return reqAPI('api/merchant/transactions/resend-callback', { transaction_id: transactionId }, 'POST')
}

export async function downloadTransactions(params = {}) {
  return reqAPI('api/merchant/transactions/download', params, 'GET', false, 'blob')
}

export async function getBankList() {
  return reqAPI('api/merchant/bank')
}

